import React from "react"
import { useTranslation } from "react-i18next"
import styled from "styled-components"
import Images from "../../images"
import Button from "../../components/Button/Button"
import { RouteComponentProps } from "react-router-dom"
import ERoute from "../../ERoute"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  width: 100%;

  img {
    max-width: 290px;
    margin-bottom: 16px;
  }
`

const Title = styled.div`
  line-height: 20px;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
`

const Description = styled.div`
  font-size: 14px;
  text-align: center;
  max-width: 384px;
  margin-bottom: 16px;
`

type IProps = {
} & RouteComponentProps


const ConnectChannel = (props: IProps) => {
  const { t } = useTranslation()

  const onConnectChannelClick = () => {
    props.history.push(ERoute.PATH_WIDGETS)
  }

  return (
    <Container>
      <img src={Images.CONNECT_CHANNEL} />

      <Title>{t('ConnectChannel::Connect with customers on every channel')}</Title>
      <Description>{t('ConnectChannel::Manage conversations in one inbox.')}</Description>

      <Button
        type='success'
        text={t('ConnectChannel::Connect channel')}
        onClick={onConnectChannelClick}
      />
    </Container>
  )
}

export default ConnectChannel